import * as Yup from 'yup';
import { USER_PERMISSIONS, USER_TAGS_KEYS } from 'shared/constants';

export const TITLE_MAX_LENGTH = 40;
export const OPTIONS_DEFAULTS = {
  onWorkingHours: false,
  sendByEmail: true,
};

export const MESSAGE_SCHEMA = Yup.object().shape({
  title: Yup.string().min(2).max(TITLE_MAX_LENGTH).required('Required'),
  content: Yup.string().min(2).required('Required'),
  options: Yup.object().shape({
    onWorkingHours: Yup.boolean(),
    sendByEmail: Yup.boolean(),
  }),
  recipientsGroups: Yup.array().of(
    Yup.object().shape({
      [USER_TAGS_KEYS.DEPARTMENT]: Yup.string(),
      [USER_TAGS_KEYS.ROTATION]: Yup.string(),
      [USER_TAGS_KEYS.ROLE]: Yup.string(),
      [USER_TAGS_KEYS.LEVEL_OF_TRAINING]: Yup.string(),
      [USER_TAGS_KEYS.PROFESSION]: Yup.string(),
      [USER_TAGS_KEYS.LOCATION]: Yup.string(),
      [USER_TAGS_KEYS.DIVISION]: Yup.string(),
      [USER_TAGS_KEYS.SPECIALTY]: Yup.string(),
      [USER_TAGS_KEYS.UNIT]: Yup.string(),
      [USER_TAGS_KEYS.PERMISSIONS]: Yup.string().oneOf(Object.values(USER_PERMISSIONS)),
    }),
  ),
  individuals: Yup.array().of(Yup.string()),
  attachments: Yup.array().of(
    Yup.object().shape({
      id: Yup.string(),
      url: Yup.string(),
      title: Yup.string().required(),
      type: Yup.string().required(),
      createdBy: Yup.string().required(),
    }),
  ),
});
